// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";
import { setApiTimestamp } from "_core/slices/datas/TransactionSlice";


// HRニューススライド削除（論理削除）
const AdminHrNewsDeleteApi = () => {
    const dispatch = useDispatch();
    const url = "/admin/hr_news_delete";

    const ExecAdminHrNewsDeleteApi = async (id) => {
        const requestParams = { id };

        let response = null;
        let error = null;
        try {
            response = await ApiRequest({ url, requestParams });
        } catch (e) {
            error = e;
        }

        if (response !== null && response.error_code === 0) {
            dispatch(setApiTimestamp(response['now_time']));
        }
        return { response, error };
    };

    return ExecAdminHrNewsDeleteApi;
};

export default AdminHrNewsDeleteApi;
